module.exports = __webpack_public_path__ + "static/media/SecretDiary.13cde0cc.jpeg";